import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import useScroll from '@/hooks/useScroll';
import appLogger from '@public/log/monitor';
import agentPageStore from '../store';
import ListItem from './list-item';
import WorkflowItem from './workflow-item'
import userStore from '@/store/user';
import CreateBtn from './create-btn';
import AgentInput from './agent-input';
import globalStore from '@/store/global';
import { INVITE_STATUS_ACTIVE } from '@/components/modal/invite-form/constant';
import TopTab from './top-tab';
import InviteBtn from './invite-btn';
import EE from '@/common/event';
import ScrollView from '@/ui/scroll-view';
import Tooltip from "@/ui/tooltip"
import ChatInput from '@/components/chat/ChatInput';
import urlStore from '@/store/chat/urlStore';
import inputTypeStore from '@/components/input-file/input-type';
import { request } from "@/common";
import ScrollToTop from '@/components/scroll-top';
import InviteUseBtn from './invite-use-btn';
import VipTag from '@/components/agent-limit/vip-tag';
import AgentLimit from '@/components/agent-limit';
import ShowBlance from '@/components/agent-limit/showBlance';
import { useMeasure } from 'react-use';
import navbarStore from '@/store/navbar';

const SquarePage = observer(props => {
  const [showTopTab, setShowTopTab] = useState(false);
  const [scroll, scrollElementRef] = useScroll();
  const listWrapRef = useRef(null);
  const [agentInfo, setAgentInfo] = useState({})
  const [showScrollToTop, setShowScrollToTop] = useState(false)
  const [headerRef, { width: widthHeaderContainer }] = useMeasure();
  const [smallTab, setSmallTab] = useState(false);

  const handleSend = (prompt, extras = {}) => {
    let text = prompt
    urlStore.newAiAgentChat("9113bbe12b834c298ab65f7e54edbfd0", text, {
      ...inputTypeStore.getSendParams(),
    })
  } 

  const handleSendAgent = extras => {
    let { input } = extras
    handleSend(input, extras)
  }

  useEffect(() => {
    EE.emit('sroll_on_blur');
    if (listWrapRef?.current) {
      setShowTopTab(scroll > listWrapRef.current.offsetTop + 160);
    }

    return () => {
      agentPageStore.switchTab(0);
    };
  }, [scroll]);

  useEffect(() => {
    if (!userStore.isUser) return;
    globalStore.getInviteStaus();
  }, [userStore.isUser]);

  useEffect(() => {
    appLogger.log({
      key: 'aibot_agent',
      action: 'show',
      page: 'agent_place',
    });
    agentPageStore.updateChatLimit();

    request('/ai_agent/detail', {
      method: 'get',
      params: {
        id: "9113bbe12b834c298ab65f7e54edbfd0",
      }
    }).then(res => {
      if (res.code !== 0) return
      setAgentInfo(res.data || {})
    })
  }, []);

  useEffect(() => {
      setSmallTab(widthHeaderContainer < (agentPageStore.isFocus ? 1200 : 900));
  }, [agentPageStore.isFocus, widthHeaderContainer])

  return (
    <div 
      className="w-full h-full flex flex-col relative"
      style={{
        backgroundImage: `url(https://p2.ssl.qhimg.com/t110b9a93013be09a129a3803c2.png)`,
        backgroundSize: '20px 20px'
      }}
    >
      <div
        style={{
          // paddingLeft: `calc((100% - 800px) / 2)`,
          background: !showTopTab ? `linear-gradient(
              to bottom,
              rgba(255,255,255,1),    /* 起始颜色和位置 */
              rgba(255,255,255,0)   /* 结束颜色和位置 */
          )` : "#ffffff"
        }}
        className="relative h-72px w-full py-18px px-24px z-9 box-border"
      >
        {/* {showTopInput ? <AgentInput scene={'top'} /> : null} */}
        {showTopTab ? (
          <div
            style={{
              paddingLeft: `calc((100% - 800px) / 2)`,
            }}
            className="absolute left-0 top-68px w-full pb-12px bg-white"
          >
            <TopTab />
          </div>
        ) : null}
        <div 
          className={[
            "flex items-center",
            navbarStore.isCollapse ? "pl-80px" : ""
          ]}
          ref={headerRef}
        >
          {/* {userStore.isUser &&
          globalStore.inviteCodeStatus === INVITE_STATUS_ACTIVE ? (
            <InviteBtn />
          ) : null} */}
          {userStore.isUser && typeof agentPageStore?.chatLimit?.is_new === 'boolean' ? (agentPageStore?.chatLimit?.is_new ? <InviteUseBtn className="z-10 mr-0" /> : globalStore.inviteCodeStatus === INVITE_STATUS_ACTIVE ? <InviteBtn className="z-10 mr-10px" small={smallTab}/> : <InviteUseBtn className="z-10 mr-0" />) : null}
          <AgentLimit pos='aisquare' isLimitedAgent={globalStore?.isLimitedAgent(agentInfo?.id)} className="mr-10px h-32px"/>
          {userStore.isUser ? <ShowBlance className='mr-10px' /> : null}
          <div className='w-0px flex-grow'></div>
          <AgentInput scene={'top'} />
          {userStore.isUser ? <CreateBtn small={smallTab} /> : null}
          {
            userStore.isUser 
            ? (
              <Tooltip title={smallTab ? "我的智能体" : ""}>
                <div 
                  className={[
                    'h-32px rounded-full flex items-center box-border border-1px border-solid border-[rgba(0,0,0,0.16)] px-12px gap-6px ml-10px hover:bg-[rgba(0,0,0,0.03)] cursor-pointer mr-10px',
                    smallTab ? "px-6px" : ""
                  ]}
                  onClick={() => {
                    globalStore.navigate("/tools/aiagent/mine")
                  }}
                >
                  <img
                    src="https://p1.ssl.qhimg.com/t110b9a9301dc69af19a632795d.png"
                    className='size-20px'
                  />
                  {
                    !smallTab
                    ? (
                      <div>我的智能体</div>
                    )
                    : null
                  }
                </div>
              </Tooltip>
            )
            : null
          }
        </div>
      </div>
      <ScrollView
        ref={scrollElementRef}
        className="w-full h-0 flex-grow !p-0px"
        onScroll={(event) => {
          setShowScrollToTop(event.target.scrollTop > window.innerHeight)
        }}
      >
        <div className='relative'>
          <div className='relative z-2'>
            <div className="w-800px mx-auto mb-32px mt-100px">
              <div className="flex items-start justify-center h-48px mb-12px">
                <div className='leading-48px text-black text-34px font-bold'>
                  超级智能体
                </div>
                <span className="text-14px leading-14px text-bold-600 text-[#FF7307] px-6px py-4px ml-0px " style={{ borderRadius: '10px 10px 10px 2px' }}>
                   <VipTag  url='https://p2.ssl.qhimg.com/t110b9a9301da99165c123c42a2.png' />
                </span>
              </div>
              <div className="text-16px leading-22px text-black text-center mb-20px">
                集合多家先进大模型、MCP工具链、AI知识库能力全配齐，帮你高效完成每一个项目^_^
              </div>
            </div>
            <ChatInput
              agentInfo={agentInfo}
              scene="square"
              classname={["w-800px", "mx-auto", "border-1px", "border-solid", "border-black", "!rounded-12px", "border-opacity-100"]}
              style={{boxShadow:'0px 4px 8px 0px rgba(0, 0, 0, 0.12)'}}
              handleSendAgent={handleSendAgent}
              chatLimit={agentPageStore.chatLimit}
              placeholder="请给我明确指令，例如：帮我生成一份介绍恐龙的儿童故事绘本"
            />
            <div ref={listWrapRef} className="w-800px mx-auto mt-20px">
              {agentPageStore.agentList.map((item, index) => {
                return (
                  <ListItem
                    className=""
                    key={index}
                    item={item}
                    scroll={scroll}
                    index={index}
                  />
                );
              })}
            </div>
          </div>
          <div 
            className='absolute w-full h-full z-1 left-0 top-0 flex flex-col pointer-events-none'
          >
            <div style={{
              height: "calc(100vh - 672px)"
            }}></div>
            <div 
              className='bg-black h-0 flex-grow w-full'
              style={{
                background: `linear-gradient(
                  to bottom,
                  rgba(255,255,255,0) 0,
                  rgba(255,255,255,1) 500px
                )`,
              }}
            ></div>
          </div>
        </div>
      </ScrollView>
      {
        showScrollToTop
        ? <ScrollToTop 
            onClick={() => {
              scrollElementRef?.current?.scrollTo({
                left: 0,
                top: 0,
                behavior: "smooth",
              });
            }}
            className="absolute right-30px bottom-75px bg-white"
          />
        : null
      }
    </div>
  );
});

export default SquarePage;
